const MinuteValuesToggleEndpoint = {
  GET_MINUTE_VALUES_TOGGLE: '/default/minute-values-toggle/get-is-toggle-selected',
  SET_MINUTE_VALUES_TOGGLE: '/default/minute-values-toggle/set-is-toggle-selected',
};

export default MinuteValuesToggleEndpoint;
